import React from 'react'
import { ChangeEvent, ReactNode, useEffect, useRef } from 'react'

import { adjustLabelForOptionality } from './Option'
import { ProductOptionWithNameProps } from '../../../../../shared/js/Module'

const TextArea = ({
  details,
  disabled,
  id,
  label,
  name,
  onChange,
  required,

  triggerFocus,
  values: [value],
  valid,
}: ProductOptionWithNameProps) => {
  const inputId = `textarea-${id}`
  const descriptionId = details ? `description-textarea-${id}` : null
  const ariaDescribedBy = descriptionId
    ? { 'aria-describedby': descriptionId }
    : {}
  const fieldRef = useRef<HTMLTextAreaElement>(null)

  let finalLabel: ReactNode = label
  if (!required) {
    finalLabel = adjustLabelForOptionality(label)
  }

  // When autofocus is expected, trigger it,
  // then move smoothly into view
  useEffect(() => {
    if (fieldRef.current && triggerFocus) {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' })
      fieldRef.current.focus({ preventScroll: true })
    }
  }, [triggerFocus])

  return (
    <div className='u-mb-2'>
      <label
        className='c-label c-label--image'
        htmlFor={inputId}
        {...ariaDescribedBy}
      >
        {finalLabel}
      </label>
      <textarea
        aria-required={required}
        aria-invalid={!valid}
        disabled={disabled}
        id={inputId}
        name={name}
        onChange={handleChange}
        ref={fieldRef}
      >
        {value?.text}
      </textarea>
      {!valid && (
        <p className='c-message c-message--error'>
          Vous devez renseigner cette valeur
        </p>
      )}
      {descriptionId && (
        <p id={descriptionId} className='c-message c-message--help'>
          {details}
        </p>
      )}
    </div>
  )

  function handleChange({
    target: { value: text },
  }: ChangeEvent<HTMLTextAreaElement>) {
    onChange?.(id, [{ ...value, text }])
  }
}

export default TextArea
